import { Special } from '@common/entities';

import type { SaveResponseProps } from 'hooks/useSaveResponse';
import { AddonOption } from 'types/addon';
import handleError from 'utils/handleError';

/**
 * Returns route `propertyId` or null after surfacing a user-facing error.
 */
export function validatePropertyId(propertyId: number | undefined): number | null {
  if (!propertyId) {
    handleError(`Form Viewer - Property ID not available`, `Property ID not available`);
    return null;
  }
  return propertyId;
}

export interface BuildPageRequestDataParams {
  activeStepIndex: number;
  newPageIndex: number;
  pages: { id: string }[];
  applicationId: string;
  propertyId: number;
  getPageResponses: () => { [key: string]: unknown }[];
  errorCount: number;
  addOns?: AddonOption[];
  selectedSpecials?: Special[];
}

export function buildPageRequestData(params: BuildPageRequestDataParams): {
  requestData: SaveResponseProps;
} {
  const {
    activeStepIndex,
    newPageIndex,
    pages,
    applicationId,
    propertyId,
    getPageResponses,
    addOns,
    selectedSpecials,
    errorCount,
  } = params;

  const responses: { [key: string]: unknown }[] = [];

  if (addOns !== undefined) {
    responses.push({ addOns });
  }

  if (selectedSpecials !== undefined) {
    responses.push({ selectedSpecials });
  }

  responses.push(...getPageResponses());

  const requestData: SaveResponseProps = {
    currentPageId: pages[activeStepIndex].id,
    targetPageId: pages[newPageIndex].id,
    applicationId,
    propertyId: propertyId as unknown as number,
    responses: responses as { [key: string]: any }[],
    errorCount,
  };

  return { requestData };
}
